const PublicRoute = ({ children, redirectTo }) => {
	return children;
}

export default PublicRoute;